import { Component, Input } from '@angular/core';


const PASSWORD_VALIDATION_RULES = [
  { name: 'length', title: 'REGULAR.ERROR_MESSAGES.PASSWORD.SECURITY.LENGTH' },
];

@Component({
  selector: 'app-password-strength-visualizer',
  templateUrl: './password-strength-visualizer.component.html',
  styleUrls: ['./password-strength-visualizer.component.scss']
})
export class PasswordStrengthVisualizerComponent {
  @Input() passwordErrors: { [key: string]: boolean } | null;

  public readonly passwordValidationRules = PASSWORD_VALIDATION_RULES;

  constructor() {
  }

  hasError(name?) {
    if (!this.passwordErrors) {
      return false;
    }

    if (name) {
      return this.passwordErrors[name];
    }

    return true;
  }
}
